import { LoanProductCategory } from '@appTypes/LoansApi.interface'

function getCategoryByCategoryId<T extends { id: string }>(
    categories: T[],
    categoryId: LoanProductCategory
) {
    return categories?.find(category => category.id === categoryId)
}

export default getCategoryByCategoryId
